import { AxiosCallPostWithErr2 } from './apicall'
import { LynxUtils } from '@/utils'
import FindKeyConstants from '@/utils/FindKeyConstants.js'
import debounce from 'debounce-async'

const debouncedAutoCompleteEntities = LynxUtils.DebounceWithTryCatch([], debounce(AxiosCallPostWithErr2, 700))
export default class EntityService {
  /**
 * Constructor.
 * @param {string} baseUrl Base url to connect to lynx API. typically http or https//[ip]/lynxapi
 */
  constructor (baseUrl) {
    this.baseUrl = baseUrl
  }

  async autocompleteEntity (strSearch) {
    const fr = {
      SearchKeys: {
        [FindKeyConstants.AUTOC_FILTER]: strSearch,
        [FindKeyConstants.FR_FIND_MAX_VAL]: 100
      }
    }
    const res = await debouncedAutoCompleteEntities('lynxapi/entity/findentities', fr)
    return res?.result ?? []
  }
}
